<template>
  <ModalDialog
    ref="dialog"
    title="Supplier Shipped"
    :submitting="submitting"
    submitTitle="Confirm"
    icon="fa-truck-container"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="dialogForm" :labelColumnSize="3">
      <FormRow label="Shipping Container Reference" v-if="isBulk">
        <FormInputText v-model="confirmInfo.supplierShipContainerRef" field="supplierShipContainerRef" />
      </FormRow>
      <FormRow label="Received Advisory Date">
        <FormCheckbox v-model="confirmInfo.isDateAdvised" />
      </FormRow>
      <FormRow label="Receiving Date Advised" v-show="confirmInfo.isDateAdvised">
        <FormDate v-model="confirmInfo.dateAdvised" field="dateAdvised" />
      </FormRow>
      <FormRow label="Advised Note" v-show="confirmInfo.isDateAdvised">
        <FormInputText v-model="confirmInfo.advisedNote" field="advisedNote" />
      </FormRow>
      <!-- TODO: Tracking details for non-bulk POs? -->
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'

export default {
  name: 'SupplierShippedDialog',
  mixins: [
    ModalDialogMixin,
    form
  ],
  components: {
    ModalDialog,
  },
  props: {
    isBulk: Boolean,
    purchaseOrderId: Number,
  },
  watch: {
    
  },
  data() {
    return {
      dialogForm: {},
      submitting: false,
      confirmInfo: {
        supplierShipContainerRef: '',
        isDateAdvised: false
      },
    }
  },
  mounted() {
  },
  computed: {
  },
  methods: {
    show() {
      // Reset form
      this.confirmInfo = { supplierShipContainerRef: '', isDateAdvised: false }
      this.dialogForm = { }

      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      var confirmData = {
        supplierShipContainerRef: this.confirmInfo.supplierShipContainerRef
      }
      if(this.confirmInfo.isDateAdvised) {
        confirmData.dateAdvised = this.confirmInfo.dateAdvised
        confirmData.advisedNote = this.confirmInfo.advisedNote
      }

      this.$apiService.purchasingService.supplierShippedPurchaseOrder(this.purchaseOrderId, confirmData)
      .then(response => {
        this.modalClosed(true)
        this.hide()
      })
      .catch(err => {
        this.$data.dialogForm = this.processFormResponse(err)
      })
      .finally(() => {
        this.$data.submitting = false
      })
    }
  }
}
</script>